export const STUDIO_LOGO_ICON =
  "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/734415b037b979fae6225208f31eef48a928b10acf27a17be09c7f49749070f1.jpeg";

export const STUDIO_HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/7ec52424d938e4e2ab2feb69dc48d46dfed52c0459829925cd9ca4a615a6256a.jpeg";

export const STUDIO_PROJECTS = [
  {
    id: "ng-construction",
    name: "NG Construction",
    type: "Construction & Maintenance Website",
    category: "Websites",
    exampleUrl: "https://ngconstruction242.com/",
    features: ["Service Showcase", "Project Gallery", "Request a Quote", "Contact & Location"],
    image:
      "https://s.wordpress.com/mshots/v1/https%3A%2F%2Fngconstruction242.com%2F?w=1200&h=900",
  },
  {
    id: "mr-williams-electrical",
    name: "Mr. Williams Electrical",
    type: "Electrical Website",
    category: "Websites",
    exampleUrl: "https://smselectrical.com/",
    features: ["Service Showcase", "Project Gallery", "Quote Request", "Contact & Location"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/09fbc1e0f77725308229157cc52543429ad0caa8cb55dc081b8cc1becc6b5711.jpeg",
  },
  {
    id: "zann-industries",
    name: "Zann Industries",
    type: "Surveillance & Drone Mapping Website",
    category: "Websites",
    features: ["Service Overview", "Project Gallery", "Request a Quote", "Contact & Location"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/0a64aa6b81b6fd56915a89a2d18bc14c2dd81b5ec73eb2c0cc2848ef3bb6ccd1.jpeg",
  },
  {
    id: "gibson-son-plumbing",
    name: "Gibson & Son Plumbing",
    type: "Plumbing Service Website",
    category: "Websites",
    exampleImage:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_idea-hub-409/artifacts/kn3m3igi_ChatGPT%20Image%20Sep%2010%2C%202026%2C%2010_08_04%20AM.png",
    features: ["Service Pages", "Request a Quote", "Project Gallery", "Contact & Call Integration"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/ba1c2a5fbfd170e35608777dd3412bb1a6fac8f86bb14f2846b6e356ef5479f0.jpeg",
  },
  {
    id: "data-earth-surveying",
    name: "Data Earth Surveying",
    type: "Surveying Website + Request System",
    category: "Websites",
    exampleUrl: "https://dataearthsurveying.com/",
    features: ["Service Request Form", "Project Showcase", "Interactive Services", "Contact & Quote System"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/aaaa3a0ecc5c7e553344cc6fd16797c7ae6f67aa24eae033036ab489683a08c8.jpeg",
  },
  {
    id: "menzy-barbershop",
    name: "Barbershop Website Bookings",
    type: "Barber Website + Booking",
    category: "Websites",
    exampleUrl: "https://menzybarber.com/",
    features: ["Online Booking", "Service Menu", "Our Barbers", "Contact & Location"],
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_idea-hub-409/artifacts/q7gie8ly_ChatGPT%20Image%20Sep%206%2C%202026%2C%2009_09_25%20AM.png",
  },
  {
    id: "russells-plumbing",
    name: "Russell's Plumbing",
    type: "Plumbing Service Website",
    category: "Websites",
    exampleImage:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_idea-hub-409/artifacts/xbicdiye_ChatGPT%20Image%20Sep%2010%2C%202026%2C%2004_45_42%20PM.png",
    features: ["Service Pages", "Online Booking", "Emergency Contact", "Reviews"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/0e28bfb008b66b594850b83abaaed4b622e726520ed8740f9ec10242c61c4511.jpeg",
  },
  {
    id: "quickbook-app",
    name: "QuickBook Appointments",
    type: "Booking Mobile App",
    category: "Apps",
    features: ["Calendar Booking", "Reminders", "Customer Profiles", "Payments"],
    portrait: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/bf091e27acd23409201e7ee381f83dd6d78036626356f8669bf3502cd5b23ce0.jpeg",
  },
  {
    id: "shoplocal-app",
    name: "ShopLocal",
    type: "E-Commerce Mobile App",
    category: "Apps",
    features: ["Product Catalog", "Cart & Checkout", "Order Tracking", "Push Offers"],
    portrait: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/5264ce3f-3950-433d-af22-843e1089946b/images/013ec430f0d6e43fcafc1fac3c9a47cee345c7fc64165d9520bab1745fe8255c.jpeg",
  },
];

export const STUDIO_TABS = ["All", "Websites", "Apps"];

export const STUDIO_SERVICES = [
  "Business Websites",
  "Booking Websites",
  "E-Commerce",
  "Mobile Apps",
  "Customer Portals",
  "Request/Quote Systems",
  "Custom Digital Solutions",
];

export const WHATSAPP_NUMBER = "12424556893";
export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
